import React, { Component } from 'react';
import { connect } from 'react-redux';
import './LogIn.module.scss';
import {history} from 'components/App/components/UnauthenticatedApp';

import ButtonTransparentWhite from 'components/UI/ButtonTast/ButtonTransparentWhite/ButtonTransparentWhite';
import ButtontransparentYellow from 'components/UI/ButtonTast/ButtonTransparentYellow/ButtonTransparentYellow';
import ButtonYellow from 'components/UI/ButtonTast/ButtonYellow/ButtonYellow';
import ButtonText from 'components/UI/ButtonTast/ButtonText/ButtonText';

import loginUser from 'actions/authentication/login';

const mapDispatchToProps = {
    loginUser
};

class Login extends Component {
    
    constructor() {
        super();

        this.state = {
            email: '',
            password: ''
        }

        this.handleLogin = this.handleLogin.bind(this);

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }

    handleEmailChange(event) {
        this.setState({email: event.target.value});
    }

    handlePasswordChange(event) {
        this.setState({password: event.target.value});
    }

    handleLogin() {
        this.props.loginUser(this.state).then(Result => {

        }).catch((error) => {
            alert('Combinatie email/wachtwoord niet correct');
        });
    }

    render() {        
        return (
            <div styleName="container">
                <div styleName="art">
                    <div styleName="logoContainer">
                    </div>
                    <ButtonTransparentWhite text='NAAR PRODUCT INFORMATIE' link='https://www.studiotast.com/goto'/>
                </div>
                <div styleName="login">
                    <div styleName="form" style={{top:'45%'}}>
                        <h2>INLOGGEN</h2>
                        <form>
                          <label>Email-adres</label><input onChange={this.handleEmailChange} type="text" name="email"/><br/>
                          <label>Wachtwoord</label><input onChange={this.handlePasswordChange} type="password" name="password"/><br/>
                            
                        </form>
                            <ButtonYellow text='INLOGGEN' handleClick={this.handleLogin} />
                            <ButtontransparentYellow text='NOG GEEN GOTO ACCOUNT?' link='/aanmelden'/>
                            <ButtonText text='Wachtwoord vergeten?' link='/wachtwoordvergeten'/>
                    </div>
                    <div styleName="footnote1">
                        <p styleName="footnotetext1">Een product van</p>
                        <a href="http://www.studiotast.com"><div styleName="studiologocontainer">
                        </div></a>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./resources/assets/screens/LogIn/LogIn.jsx